module.exports = __webpack_public_path__ + "static/media/no-need.58ac7a1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/no-need.svg
// module id = 784
// module chunks = 0